var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-panel"},[_c('h3',{staticClass:"preview-title"},[_vm._v(_vm._s(_vm.$t("common.previewStructure")))]),_c('div',{staticClass:"tree-container eg-tree"},[_c('Tree',{attrs:{"value":_vm.nodes,"selection-mode":"single","selection-keys":_vm.localSelectedNode},on:{"update:selection-keys":_vm.updateSelectedNode},scopedSlots:_vm._u([{key:"default",fn:function({ node }){return [_c('eg-icon',{class:{
            'folder-icon': node.icon === 'folder',
            'last-folder':
              node.icon === 'folder' &&
              !(node.children && node.children.length),
          },attrs:{"icon":node.icon}}),_c('div',{staticClass:"node-label"},[_vm._v(_vm._s(node.label))])]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }